import AppBackgroundColor from '@components/app-background-color/AppBackgroundColor';
import HubSpotForm from '@components/hubspot/HubSpotForm';
import { ContentBlock } from '@layouts/ContentBlocks';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import useBreakpoints from '@ui/hooks/useBreakpoints';
import { makeSeoData } from 'config/next-seo.config';
import Head from 'next/head';
import Image from 'next/image';
import { NextSeo } from 'next-seo';
import React from 'react';

import useStyles from './design.style';

const title = 'One-on-one design consults with our team.';
const description = 'Looking to curate your next space? We\'d love to help. Submit your information below to get started with one of our professional designers.';

export default function Design() {
  const { classes, theme } = useStyles();
  const { md } = useBreakpoints();
  

  return (
    <>
      <AppBackgroundColor backgroundColor={theme.palette.pink.light} />
  
      <Head>
        <title>
          {title}
        </title>
      </Head>

      <NextSeo {...makeSeoData({ pageTitle: title, metaTitle:title, metaDescription: description })} />

      <ContentBlock
        maxWidth={1365}
      >
        <Grid
          container
          justifyContent="space-between"
          spacing={10}
        >
          <Grid
            item
            xs={12}
            md={6}
            style={{
              paddingTop: md ? 80 : 0
            }}
          >
            <Typography
              variant="h1"
              className={classes.heading}
            >
              {title}
            </Typography>

            <Typography className={classes.text}>
              {description}
            </Typography>

            <HubSpotForm
              portalId= "8563089"
              formId= "f20f714e-8468-4fcd-86ee-7fbee74473dc"
            />
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            className={classes.rightColumn}
          >
            <div
              style={{
                borderRadius: theme.shape.borderRadius,
                overflow: 'hidden',
                position: 'relative',
                height: md ? 660 : 600,
                width: md ? 520 : '100%',
              }}
            >
              <Image
                fill
                alt=""
                src="/images/design/design-consult.png"
                className={classes.image}
                sizes="100vw"
              />
            </div>
          </Grid>
        </Grid>
      </ContentBlock>
    </>
  );
}
